import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsUserItem extends SettingsItemForm {

  modelName = 'user'

  render() {
    const { usrgs, orgs, data, user_s } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = !!this.state.delConf && (
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
    );

    if(this.state.editing){
      let usrgsOpt = [];
      for (let key in usrgs){
        if(usrgs.hasOwnProperty(key) && (usrgs[key].usrg_active === 1
          || usrgs[key].usrg_id === nData.user_usrg_id)) {
          usrgsOpt.push({value:usrgs[key].usrg_id,label:usrgs[key].usrg_desc});
        }
      }
      usrgsOpt.sort(sortOpts);

      let orgsOpt = [];
      for (let key in orgs){
        if(orgs.hasOwnProperty(key) && (orgs[key].org_active === 1
          || orgs[key].org_id === nData.user_org_id)) {
          orgsOpt.push({value:orgs[key].org_id,label:orgs[key].org_desc});
        }
      }
      orgsOpt.sort(sortOpts);

      return(
        <tr>
          <td>
          {delConf}
          <div className="form-group">{data.user_login}</div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>{data.user_active ? 'Активен' : 'Удален'}</td>
          <td>
            <Select
              clearable={false}
              options={usrgsOpt}
              value={nData.user_usrg_id}
              onChange={e => this.updateSelect(e,'user_usrg_id')}
              placeholder="Группа пользователя"
            />
          </td>
          {!!user_s && (
            <td>
              <Select
                clearable={false}
                options={orgsOpt}
                value={nData.user_org_id}
                onChange={e => this.updateSelect(e,'user_org_id')}
                placeholder="Организация"
              />
            </td>
          )}
          <td>
            <input type="text"
              className="form-control"
              value={nData.user_fname}
              name="user_fname"
              onChange={this.updateInput}
              placeholder="Имя"
            />
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.user_lname}
              name="user_lname"
              onChange={this.updateInput}
              placeholder="Фамилия"
            />
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.user_tel}
              name="user_tel"
              onChange={this.updateInput}
              placeholder="Телефон"
            />
          </td>
          <td>
            <input type="text"
              className="form-control"
              value={nData.user_text}
              name="user_text"
              onChange={this.updateInput}
              placeholder="Должность"
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr
          onClick={this.startEditing}
          className={data.user_active ? '' : "text-info"}
        >
          <td>{data.user_login}</td>
          <td>{data.user_active ? 'Активен' : 'Удален'}</td>
          <td>{usrgs[data.user_usrg_id].usrg_desc}</td>
          {!!user_s && <td>{orgs[data.user_org_id].org_desc}</td>}
          <td>{data.user_fname}</td>
          <td>{data.user_lname}</td>
          <td>{data.user_tel}</td>
          <td>{data.user_text}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsUserItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsUserItem.js